import React from "react";
import { useParams } from "react-router";
import Layout from "../../layout/Layout";
import { Movies } from "../screen components/Data/MovieData";
import MovieCasts from "../single/MovieCasts";
import MoviesInfo from "../single/MoviesInfo";

const SingleMovies = () => {
  const { id } = useParams();
  const movie = Movies.find((movie) => movie.name === id);
  return (
    <Layout>
      <MoviesInfo movie={movie} />
      <div className="container mx-auto min-h-screen px-2 my-6">
        <MovieCasts />
      </div>
    </Layout>
  );
};

export default SingleMovies;
